"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Form = __importStar(require("../../form"));
var FormLayout = Form.FormLayout, Wrapper = Form.Wrapper, Input = Form.Input, Autocomplete = Form.Autocomplete, Switch = Form.Switch;
var FormUI = function (props) {
    var onSubmit = props.onSubmit, onChange = props.onChange, onCancel = props.onCancel, data = props.data, errors = props.errors, countryList = props.countryList;
    var handleSubmit = function (event) {
        onSubmit(event);
    };
    return (react_1["default"].createElement(FormLayout, { onSubmit: handleSubmit, onCancel: onCancel },
        react_1["default"].createElement(Wrapper, { label: data.isSet ? 'Address is set' : 'Address is not set', name: "isSet", type: "switch" },
            react_1["default"].createElement(Switch, { name: "isSet", data: data, onChange: onChange })),
        data.isSet && (react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement(Wrapper, { label: "Country", errors: errors, name: "country", type: "autocomplete" },
                react_1["default"].createElement(Autocomplete, { name: "country", data: data, onChange: onChange, promise: countryList })),
            react_1["default"].createElement(Wrapper, { label: "Zip", errors: errors, name: "zip" },
                react_1["default"].createElement(Input, { name: "zip", data: data, onChange: onChange })),
            react_1["default"].createElement(Wrapper, { label: "City", errors: errors, name: "city" },
                react_1["default"].createElement(Input, { name: "city", data: data, onChange: onChange })),
            react_1["default"].createElement(Wrapper, { label: "Street", errors: errors, name: "street" },
                react_1["default"].createElement(Input, { name: "street", data: data, onChange: onChange }))))));
};
exports["default"] = FormUI;
